import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import {BrowserRouter, Routes, Route} from 'react-router-dom'

import Recovery from './routes/RecoveryPage'
import CloudPage from './routes/CloudPage'
import ContactPage from './routes/ContactPage'
import GalleryPage from './routes/GalleryPage'

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path='/' element={<App />} />
      <Route path='/aboutme' element={<Recovery />} />
      <Route path='/services' element={<CloudPage />} />
      <Route path='/contact' element={<ContactPage />} />
      <Route path='/gallery' element={<GalleryPage />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);
